import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const usePipeAllCheck = (props: { enabled?: boolean } = {}) =>
  useQuery<crmModels.IPipeAll[]>({
    queryKey: [crmConstants.queryKeys.PIPE_ALL_CHECK],
    queryFn: async () => {
      const res = await $api.get('/v1/pipe/all-check');

      return res?.data?.data;
    },
    staleTime: Infinity,
    enabled: props?.enabled
  });
